import {NavigationTreeItem} from '~ui/components/NavigationTree/types';
import {NavigationEntityState, NavigationItemExpandedState} from '~ui/store/slices/navigation-tree';

interface GetTreeItemsListOptions {
    slug: string;
    pagesNavigationMap: Record<string, NavigationEntityState>;
    pagesMap: Record<string, {id?: number; title: string}>;
}

export const getTreeItemsList = (options: GetTreeItemsListOptions) => {
    return getTreeItemsListInner({
        ...options,
        depth: 0,
        result: [],
    });
};

interface GetTreeItemsListInnerOptions extends GetTreeItemsListOptions {
    depth: number;
    result: NavigationTreeItem[];
}

const getTreeItemsListInner = ({
    slug,
    pagesNavigationMap,
    pagesMap,
    depth,
    result,
}: GetTreeItemsListInnerOptions) => {
    const page = pagesNavigationMap[slug];

    if (!page || page.expandedState === NavigationItemExpandedState.Closed) {
        return result;
    }

    if (page.prevCursor) {
        result.push({
            isLoader: true,
            isExpander: false,
            depth,
            slug: slug,
            loading: page.loadingPrev,
            parent: slug,
            type: 'prev',
            cursor: page.prevCursor,
        });
    }

    page.children?.forEach((childSlug) => {
        const childPage = pagesMap[childSlug];
        const childNavigation = pagesNavigationMap[childSlug];

        if (!childPage || !childNavigation) return;

        result.push({
            ...childNavigation,
            id: childPage.id,
            title: childPage.title,
            slug: childSlug,
            depth,
            isLoader: false,
            isExpander: false,
            parent: slug,
            virtualSlug: childNavigation.virtualSlug,
            isFixed: childNavigation.isFixed,
        });

        getTreeItemsListInner({
            slug: childSlug,
            pagesNavigationMap,
            pagesMap,
            depth: depth + 1,
            result,
        });
    });

    if (page.expandedState === NavigationItemExpandedState.NeedsExpand) {
        result.push({
            isExpander: true,
            isLoader: false,
            depth,
            slug,
            parent: slug,
            loading: page.loading,
            children: page.children,
            expandedState: NavigationItemExpandedState.NeedsExpand,
        });
    }

    if (page.nextCursor) {
        result.push({
            isLoader: true,
            isExpander: false,
            depth,
            slug: slug,
            type: 'next',
            cursor: page.nextCursor,
            loading: page.loadingNext,
            parent: slug,
        });
    }

    return result;
};
